export enum AMResolution {
  YEARLY = "Yearly",
  QUARTERLY = "Quarterly",
  MONTHLY = "Monthly",
}

export enum AMColumn {
  BUDGETED = "Budgeted",
  AUDITED = "Audited",
  ACTUAL = "Actual",
  VARIANCE_ABSOLUTE = "Variance (Absolute)",
  VARIANCE_PERCENTAGE = "Variance (Percentage)",
}

export enum AMVarianceDisplayMode {
  ABSOLUTE = "Absolute value",
  PERCENTAGE = "Percentage",
}

export enum AMPeriodOverPeriod {
  MOM_VALUE = "MoM Value",
  MOM_PERCENTAGE = "MoM %",
  YOY_VALUE = "YoY Value",
  YOY_PERCENTAGE = "YoY %",
  QOQ_VALUE = "QoQ Value",
  QOQ_PERCENTAGE = "QoQ %",
}

export const AM_VARIANCE_COLUMN = "variance";
export const AM_UPLOAD_FILE_DIALOG_SUB_TITLE_MAX_WIDTH = "500px";
